<template>
    <div class="page m-fiscanStats">
        <el-tabs class="stats-tab" v-model="tab" type="border-card">
            <el-tab-pane label="元素图像统计" name="1">
                <fiscan-tip-stats v-if="tab==1" />
            </el-tab-pane>
            <el-tab-pane label="包裹图像统计" name="2">
                <fiscan-package-stats  v-if="tab==2" />
            </el-tab-pane>
            <el-tab-pane label="学情统计" name="3">
                <fiscan-study-stats  v-if="tab==3" />
            </el-tab-pane>
        </el-tabs>

        <transition enter-active-class="animated slideInRight"
                    leave-active-class="animated slideOutRight">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
import FiscanTipStats from './FiscanTipStats'
import FiscanPackageStats from './FiscanPackageStats'
import FiscanStudyStats from './FiscanStudyStats'

export default {
    components: {
        FiscanTipStats,
        FiscanPackageStats,
        FiscanStudyStats,
    },
    data() {
        return {
            tab: '1'
        }
    },
}
</script>

<style lang="scss">
@import "~@/style/const";

.m-fiscanStats {
    .stats-tab {
        > .el-tabs__content{
            padding: 20px 30px;
        }
    }

    .ui-card {
        box-shadow: none;
        border: 1px solid #dedede;
    }

    // 解决二级页面晃动问题
    .sub-page {
        > .el-main {
            overflow-x: hidden;
        }
    }

    .table-query {
        padding: 20px 0 10px 10px;
    }

    .slideInRight {
        animation-duration: 300ms;
    }
}
</style>
